import type { TranslationDict } from '../en';

const mt: TranslationDict = {
  'header.buy': 'Ixtri',
  'header.sell': 'Biegħ',
  'spend.label': 'Tonfoq',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Tirċievi',
  'payment.label': 'Metodu ta\' ħlas',
  'payment.select': 'Agħżel',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'L-ebda metodu ta\' ħlas għal din il-par',
  'wallet.label': 'Indirizz tal-kartiera tar-riċeviment',
  'wallet.placeholderBuy': 'Daħħal l-indirizz tar-riċeviment tiegħek',
  'wallet.placeholderSell': 'Daħħal l-indirizz tat-tbaxxija tiegħek',
  'wallet.validating': 'Qed jiġi vvalidat l-indirizz...',
  'wallet.invalid': 'Daħħal indirizz validu tal-kartiera',
  'wallet.invalidServer': 'Indirizz tal-kartiera invalidu',
  'cta.buy': 'Ixtri {crypto}',
  'cta.sell': 'Biegħ {crypto}',
  'cta.gettingPrice': 'Qed jinkiseb l-aħjar prezz...',
  'cta.processing': 'Qed jiġi pproċessat...',
  'footer.poweredBy': 'Imsaħħaħ minn ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Detalji tar-rata',
  'rate.close': 'Agħlaq',
  'rate.updatesIn': 'Ir-rata tiġġedded f\'00:{seconds}',
  'rate.noQuote': 'L-ebda kwotazzjoni disponibbli',
  'rate.exchangeRate': 'Rata tal-kambju',
  'rate.processingFee': 'Tariffa tal-ipproċessar',
  'rate.networkFee': 'Tariffa tan-netwerk',
  'rate.provider': 'Fornitur',
  'toast.orderCreated': 'Ordni maħluqa',
  'toast.redirecting': 'Qed jiġi rridirezzjonat lejn il-checkout...',
  'toast.orderFailed': 'L-ordni falliet',
  'toast.couldNotCreate': 'Ma setgħetx tinħoloq l-ordni',
  'toast.quoteError': 'Żball fil-kwotazzjoni',
  'toast.noProviders': 'L-ebda fornitur',
  'toast.somethingWrong': 'Seħħ xi ħaġa ħażina',
  'error.amountZero': 'L-ammont għandu jkun aktar minn 0',
  'error.minAmountFiat': 'L-ammont minimu huwa {min} {currency}',
  'error.minAmountCrypto': 'L-ammont minimu huwa {min} {currency}',
  'error.noProviders': 'L-ebda fornitur disponibbli għal din il-kombinazzjoni',
  'error.currencyUnavailableBuy': 'Din il-munita mhix disponibbli għal ordnijiet ta\' xiri',
  'error.currencyUnavailableSell': 'Din il-munita mhix disponibbli għal ordnijiet ta\' bejgħ',
  'parity.info': 'Se tiġi ċċarġjat għal {receiveAmount} {crypto}, il-bqija sa {spendAmount} {fiat} se jiġi kreditjat fil-kont tiegħek ta\' {partner}',
  'redirect.secureBadge': 'Ħlas sigur',
  'redirect.title': 'Kompli l-ħlas',
  'redirect.description': 'Se tiġi rridirezzjonat lejn {gateway} biex tlesti l-ħlas tiegħek.',
  'redirect.countdown': 'Ridirezjonament f\'perjodu ta\' {seconds}...',
  'redirect.openTab': 'Iftaħ ACH f\'taqbila ġdida',
  'redirect.cancel': 'Ikkanċella',
  'checkout.noOrder': 'L-ebda ordni nstabet',
  'checkout.goBack': 'Mur Lura',
  'checkout.expired': 'Il-checkout skada',
  'checkout.expiredDesc': 'Is-sessjoni skadiet. Jekk jogħġbok erġa\' pprova.',
  'checkout.startOver': 'Ibda mill-ġdid',
  'checkout.cancel': 'Ikkanċella',
  'checkout.loading': 'Qed jitgħabba l-checkout...',
  'checkout.iframeTitle': 'Checkout tal-Fornitur',
  'checkout.widgetTitle': 'Checkout tal-Ħlas',
  'checkout.unknownMethod': 'Metodu ta\' checkout mhux magħruf',
  'processing.default': 'Qed tiġi pproċessata l-ordni tiegħek...',
  'processing.pending': 'Qed jistenna l-konferma tal-ħlas...',
  'processing.active': 'Qed tiġi pproċessata t-tranżazzjoni tiegħek...',
  'processing.generic': 'Qed jiġi pproċessat...',
  'processing.checkingStatus': 'Qed jiġi kkontrollat l-istat...',
  'processing.orderId': 'ID tal-Ordni',
  'processing.provider': 'Fornitur',
  'processing.amount': 'Ammont',
  'processing.receiving': 'Qed tirċievi',
  'processing.network': 'Netwerk',
  'processing.toAddress': 'Indirizz tad-destinazzjoni',
  'processing.usuallyMinutes': 'Dan ġeneralment jieħu ftit minuti.',
  'processing.safeToClose': 'Tista\' tagħlaq din il-paġna b\'mod sigur — se nibgħatlek email meta jitlesta.',
  'complete.buyTitle': 'Ix-Xiri Lest!',
  'complete.sellTitle': 'Il-Bejgħ Lest!',
  'complete.buyDesc': 'Il-{crypto} tiegħek intbagħtet fil-kartiera tiegħek.',
  'complete.sellDesc': 'Il-ħlas tiegħek f\'{fiat} qed jiġi pproċessat.',
  'complete.amountBuy': 'Ammont Riċevut',
  'complete.amountSell': 'Ammont Mibjugħ',
  'complete.paidBuy': 'Ammont Imħallas',
  'complete.paidSell': 'Ammont tal-Ħlas',
  'complete.network': 'Netwerk',
  'complete.wallet': 'Kartiera',
  'complete.transaction': 'Tranżazzjoni',
  'complete.provider': 'Fornitur',
  'complete.orderId': 'ID tal-Ordni',
  'complete.completed': 'Lesta',
  'complete.viewExplorer': 'Ara fl-Explorer',
  'complete.done': 'Lest',
  'errorStep.failed': 'Il-Ħlas Falla',
  'errorStep.cancelled': 'L-Ordni Ikkanċellata',
  'errorStep.expired': 'L-Ordni Skadiet',
  'errorStep.refunded': 'L-Ordni Rimborżata',
  'errorStep.unknown': 'Seħħ Xi Ħaġa Ħażina',
  'errorStep.failedBuy': 'Il-ħlas tiegħek ma setax jiġi pproċessat. Jekk jogħġbok erġa\' pprova jew uża metodu ta\' ħlas differenti.',
  'errorStep.failedSell': 'Il-bejgħ tiegħek ma setax jiġi pproċessat. Jekk jogħġbok erġa\' pprova.',
  'errorStep.cancelledBuy': 'L-ordni tiegħek ġiet ikkanċellata. L-ebda ħlas ma ġie pproċessat.',
  'errorStep.cancelledSell': 'Il-bejgħ tiegħek ġie kkanċellat. L-ebda crypto ma ġie ttrasferit.',
  'errorStep.expiredBuy': 'L-ordni tiegħek skadiet. Jekk jogħġbok ibda xiri ġdid.',
  'errorStep.expiredSell': 'L-ordni tiegħek skadiet. Jekk jogħġbok ibda bejgħ ġdid.',
  'errorStep.refundedBuy': 'Il-ħlas tiegħek ġie rimborżat. Il-fondi għandhom jidhru fil-kont tiegħek fi żmien 5-10 jiem tax-xogħol.',
  'errorStep.refundedSell': 'Il-crypto tiegħek ġiet irritornata. Il-fondi għandhom jidhru fil-kartiera tiegħek dalwaqt.',
  'errorStep.genericDesc': 'Seħħ żball mhux mistenni. Jekk jogħġbok erġa\' pprova.',
  'errorStep.orderId': 'ID tal-Ordni',
  'errorStep.tryAgain': 'Erġa\' Pprova',
  'errorStep.startOver': 'Ibda mill-Ġdid',
  'errorStep.return': 'Irritorna',
  'errorStep.needHelp': 'Għandek bżonn għajnuna? Ikkuntattja ',
  'errorStep.reference': 'Referenza: {orderId}',
  'confirm.buyTitle': 'Ikkonferma x-Xiri',
  'confirm.sellTitle': 'Ikkonferma l-Bejgħ',
  'confirm.loading': 'Qed jitgħabba...',
  'confirm.provider': 'Fornitur',
  'confirm.youPay': 'Tħallas',
  'confirm.youSell': 'Tbiegħ',
  'confirm.youReceive': 'Tirċievi',
  'confirm.wallet': 'Kartiera',
  'confirm.network': 'Netwerk',
  'confirm.refundAddress': 'Indirizz tar-rimborż',
  'confirm.parityNote': 'L-ammont imċarġjat mill-fornitur jista\' jvarja. Il-bqija sa {amount} {crypto} se jiġi kreditjat fil-kont tiegħek ta\' {partner}.',
  'confirm.processing': 'Qed jiġi pproċessat...',
  'confirm.confirmPay': 'Ikkonferma u Ħallas',
  'confirm.confirmSell': 'Ikkonferma u Biegħ',
  'confirm.payout': 'Ħlas f\'{currency}',
  'modal.selectFiat': 'Agħżel munita fiat',
  'modal.selectCrypto': 'Agħżel munita crypto',
  'modal.choosePayment': 'Agħżel metodu ta\' ħlas',
  'modal.selectCountry': 'Agħżel il-pajjiż tiegħek',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Popolari',
  'modal.recommended': 'Rakkomandat',
  'modal.noCurrencies': 'Ma nstabet l-ebda munita',
  'modal.noPaymentMethods': 'Ma nstab l-ebda metodu ta\' ħlas',
  'modal.noCountries': 'Ma nstab l-ebda pajjiż',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Post',
  'settings.darkMode': 'Modalità Skura',
  'settings.privacy': 'Politika tal-privatezza',
  'settings.terms': 'Termini tal-użu',
  'settings.language': 'Lingwa',
  // ─── Additional ───
  'modal.chooseRamp': 'Agħżel Ramp',
  'modal.bestPrice': 'L-aħjar prezz',
  'modal.noQuotes': 'L-ebda kwotazzjonijiet disponibbli għal din it-talba',
  'modal.noProvidersFound': 'Ma nstab l-ebda fornitur',
  'payment.unavailableFor': 'L-ebda metodu ta\' ħlas disponibbli għal {currency}',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'Falliet il-ħolqien tal-ordni',
  'errorStep.returnToMerchant': 'Irritorna għand il-bejjiegħ',
  'confirm.cryptoOnNetwork': '{crypto} fuq {network}',
  'payment.name.card': 'Karta',
  'payment.name.bankTransfer': 'Trasferiment Bankarju',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default mt;
